import type {
  ChargeView,
  CheckoutResult,
  CreateChargeInput,
  CreateInvoiceInput,
  InvoiceView,
  PaymentView,
  RecordManualPaymentInput,
} from '@gwc/shared';
import { apiV2 } from '../lib/api';

export const billingApi = {
  listCharges: (params?: { personId?: string; status?: string; page?: number }) =>
    apiV2.list<ChargeView[]>(
      `/billing/charges${toQuery(params)}`,
    ),

  createCharge: (body: CreateChargeInput) =>
    apiV2.post<ChargeView>('/billing/charges', body),

  bulkAnnualDues: (body: { year: number; amount: number; dueDate?: string | null; memberIds?: string[] }) =>
    apiV2.post<{ created: number }>('/billing/charges/bulk-annual', body),

  listInvoices: (params?: { personId?: string; status?: string; page?: number }) =>
    apiV2.list<InvoiceView[]>(`/billing/invoices${toQuery(params)}`),

  getInvoice: (invoiceId: string) =>
    apiV2.get<InvoiceView>(`/billing/invoices/${invoiceId}`),

  createInvoice: (body: CreateInvoiceInput) =>
    apiV2.post<InvoiceView>('/billing/invoices', body),

  issueInvoice: (invoiceId: string) =>
    apiV2.post<InvoiceView>(`/billing/invoices/${invoiceId}/issue`),

  paymentHistory: (params?: { personId?: string; page?: number }) =>
    apiV2.list<PaymentView[]>(`/billing/payments/history${toQuery(params)}`),

  checkout: (body: { invoiceId?: string; chargeId?: string; provider?: 'stripe' | 'paypal' }) =>
    apiV2.post<CheckoutResult>('/billing/payments/checkout', body),

  recordManualPayment: (body: RecordManualPaymentInput) =>
    apiV2.post<PaymentView>('/billing/payments/record-manual', body),
};

function toQuery(params?: Record<string, string | number | undefined>): string {
  if (!params) return '';
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== '') q.set(k, String(v));
  }
  const s = q.toString();
  return s ? `?${s}` : '';
}
